<style lang="less" scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}

/deep/ .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
        top: 0;
    }

}

/deep/ .ivu-input-number {
    width: 100% !important;
}

.verAddCon {
    position: relative;

    .title {
        font-size: 20px;
        padding: 4px 0 20px;
    }

    .colseButton {
        position: absolute;
        right: -18px;
        top: -18px
    }
}
</style>

<template>
    <div class="verAddCon" v-if='showModel'>
        <div class="title">{{ title }}</div>
        <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />

        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <Tabs type="card">
                <TabPane :label="$t('firmwareVersion.addBox.title1')">
                    <FormItem :label="$t('editMesageModule.lang_zh')" prop="zh" style="width: 500px">
                        <Input type="text" v-model="formData.zh" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_zh_ft')" prop="zh_ft" style="width: 500px">
                        <Input type="text" v-model="formData.zh_ft" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_en')" prop="en" style="width: 500px">
                        <Input type="text" v-model="formData.en" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_fr')" prop="fr" style="width: 500px">
                        <Input type="text" v-model="formData.fr" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_de')" prop="de" style="width: 500px">
                        <Input type="text" v-model="formData.de" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_es')" prop="es" style="width: 500px">
                        <Input type="text" v-model="formData.es" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
                    <FormItem :label="$t('editMesageModule.lang_ja')" prop="ja" style="width: 500px">
                        <Input type="text" v-model="formData.ja" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
                </TabPane>
                <TabPane :label="$t('firmwareVersion.addBox.title2')">

                    <FormItem :label="$t('BasicProduct.titleName.pageId')" class="ivu-form-item-required" prop="pageId"
                        style="width: 560px;">
                        <SearchSelect ref="pageId" :url="pagesIdListUrl" labelName='pageId' isMultiple='2' valName='pageId'
                            labelNameNew="description" keyword="pageId" :labelInValue="true"
                            :placeholderText="type == 1 ? $t('selectPlaceholder') : $t('selectloadingPlaceholder')"
                            @setSelected="setSelectVal($event, 'pageId')"></SearchSelect>
                    </FormItem>

                    <FormItem :label="$t('appDevice.titleName.pageVersion')" prop="pageVersion" style="width: 560px">
                        <Input type="text" v-model.trim="formData.pageVersion" :disabled="type==2"
                            :placeholder="$t('inputPlaceholder') + $t('appVersion.example')"></Input>
                    </FormItem>


                    <FormItem :label="$t('appDevice.titleName.appVersion')" class="ivu-form-item-required" prop="appVersion"
                        style="width: 560px;">
                        <Input type="text" v-model.trim="formData.appVersion"
                            :placeholder="$t('inputPlaceholder') + $t('appVersion.example')"></Input>

                    </FormItem>


                    <FormItem :label="$t('appVersion.titleName.os')" prop="os" class="ivu-form-item-required"
                        style="width: 560px">
                        <RadioGroup v-model="formData.os">
                            <Radio :label="item.id" v-for="(item) in osList" :key='item.id'>
                                <span>{{ item.name }}</span>
                            </Radio>
                        </RadioGroup>
                    </FormItem>



                    <FormItem :label="$t('appVersion.titleName.releaseType')" class="ivu-form-item-required"
                        prop="releaseType" style="width: 560px">
                        <RadioGroup v-model="formData.releaseType">
                            <Radio :label="item.id" v-for="(item) in typeList" :key='item.id'>
                                <span>{{ item.name }}</span>
                            </Radio>
                        </RadioGroup>
                    </FormItem>

                    <FormItem :label="$t('appVersion.titleName.fileName')" prop="fileName" class="ivu-form-item-required"
                        style="width: 500px">
                        <upload-file ref='upFile' :num='1' :action='upFileUrl' :types='["bin","zip"]'
                            :formatError="$t('appVersion.require.formatError')" @setThumbUrl='setThumbUrl'></upload-file>
                        <div>{{ formData.fileId }}</div>
                    </FormItem>

                    <FormItem :label="$t('appVersion.titleName.releaseDate')" prop="releaseDate1" style="min-width: 560px">
                        <DatePicker :value="formData.releaseDate1" type="date" transfer
                            :placeholder="$t('selectPlaceholder')" @on-change='selectT' format="yyyy-MM-dd"
                            style="width: 440px"></DatePicker>
                    </FormItem>
<!-- 
                    <FormItem :label="$t('appDevice.titleName.status')" prop="versionStatus" class="ivu-form-item-required"
                        style="width: 560px">
                        <RadioGroup v-model="formData.versionStatus">
                            <Radio :label="item.id" v-for="(item) in statusList" :key='item.id'>
                                <span>{{ item.name }}</span>
                            </Radio>
                        </RadioGroup>
                    </FormItem> -->



                    <FormItem :label="$t('accountRecharge.titleName.remark')" prop="remark" style="width: 560px">
                        <Input maxlength="100" show-word-limit type="textarea" v-model.trim="formData.remark"
                            :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>


                    <FormItem>
                        <Button :loading="disabled" type="primary" @click="subData('formData')"
                            style="marginRight:20px">{{ $t('save') }}</Button>
                        <Button :disabled="disabled" @click="cancel">{{ $t('cancel') }}</Button>
                    </FormItem>
                </TabPane>
            </Tabs>

        </Form>

        <!-- </Modal> -->
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import SearchSelect from '../../common/selectList.vue';  //20220415
import uploadFile from '../../common/uploadFiles.vue'

import { mapState } from 'vuex'
export default {
    props: {
        showModel: Boolean,
        fn: Function,
        type: Number,
        editFormData: Object,
        offModel: Boolean
    },
    name: "Model3",
    components: {
        SearchSelect,
        uploadFile
    },
    data() {
        return {
            upFileUrl: this.config.urlArray.uploadImg,
            pagesIdListUrl: this.config.urlArray.pagesIdList,//页面编号
            appsListUrl: this.config.urlArray.apps,//app编号
            disabled: false,//禁用确定按钮
            title: '',//弹框标题
            formData: {//表单数据
                pageId: '',
                pageVersion: '',
                appVersion: '',
                os: '1',
                osType: "1",
                releaseType: '0',
                versionStatus: '1',
                fileId: '',
                remark: '',
                versionInformation: '',
                releaseDate: '',
                releaseDate1: '',
                zh: '',
                zh_ft: '',
                en: '',
                fr: '',
                de: '',
                es: '',
                ja: '',
            },
            selectUrlQuery: {
                os: '1'
            }

        }
    },
    watch: {
        showModel(val) {
            if (val === true) {

                this.title = this.type == 1 ? this.$t("appDevice.addButton") : this.$t("appDevice.editButton")

                this.$nextTick(() => {//select赋值
                    this.$refs.pageId.setQuery(null)

                });

                if (this.type == 2) {
                    //  console.log(this.editFormData)

                    for (let key in this.editFormData) {
                        if (this.formData.hasOwnProperty(key)) {
                            this.formData[key] = this.editFormData[key]
                        }
                    }

                    this.formData.id = this.editFormData.id
                    this.formData.pageId = this.editFormData.pageId + ''
                    this.formData.fileId = this.editFormData.fileId + ''
                    this.formData.os = this.editFormData.os + ''
                    this.formData.releaseType = this.editFormData.releaseType + ''
                    this.formData.versionStatus = this.editFormData.versionStatus + ''
                    this.selectUrlQuery.os = this.formData.os
                    this.formData.releaseDate1 = moment(this.editFormData.releaseDate * 1).format('YYYY-MM-DD');

                    let versionInformation =  this.editFormData.versionInformation
                    console.log(versionInformation.split('&de&'))
                   
                     this.formData.zh= (versionInformation.split('&zh&'))[1]
                     this.formData.zh_ft= (versionInformation.split('&zh_TW&'))[1]
                     this.formData.en= (versionInformation.split('&en&'))[1]
                     this.formData.fr= (versionInformation.split('&fr&'))[1]
                     this.formData.de= (versionInformation.split('&de&'))[1]
                     this.formData.es= (versionInformation.split('&es&'))[1]
                     this.formData.ja= (versionInformation.split('&ja&'))[1]




                    this.$nextTick(() => {//select、图片赋值

                        this.$refs.pageId.setDefVal(Number(this.formData.pageId));

                        // let hasUpload = [{
                        //    status: 'finished',
                        //    response: { data: this.editFormData.fileId }
                        //  }]
                        //  this.$refs.upFile.setHasUpload(hasUpload)// 为上传组件付默认值
                    });


                }
            } else { //关闭弹框后要做的处理
                this.resetForm();//重置表单
                this.$refs.pageId.clearVal();
                this.$refs.upFile.clearImg()

            }
        },
    },
    computed: {

        ...mapState(['local', 'selectId']),
        osList() {
            return [
                { id: '1', name: 'andrios' },
                { id: '2', name: 'ios' },
            ]
        },
        typeList() {
            return [
                { id: '0', name: this.$t('selectList.releaseTypeList.beta') },
                { id: '1', name: this.$t('selectList.releaseTypeList.release') },
            ]
        },
        statusList() {
            return [
                { id: '1', name: this.$t('selectList.appStatusList.Online') },
                { id: '2', name: this.$t('selectList.appStatusList.Expired') },
            ]
        },
        ruleCustom() {
            return {//验证
                pageId: [
                    { required: true, message: this.$t('required'), trigger: 'change' },
                ],
                releaseDate1: [
                    { required: true, message: this.$t('required'), trigger: 'change' },
                ],
                appVersion: [
                    { required: true, message: this.$t('required'), trigger: 'blur' },
                    { required: true, RegExp: '^([1-9]\d|[1-9])(\.([0-9]\d|\d)\.([1-9]))$', message: this.$t('required'), trigger: 'blur' },
                ],
                pageVersion: [
                    { required: true, message: this.$t('required'), trigger: 'blur' },
                    { required: true, RegExp: '^([1-9]\d|[1-9])(\.([0-9]\d|\d)\.([1-9]))$', message: this.$t('required'), trigger: 'blur' },
                ],
                fileId: [
                    { required: true, message: this.$t('required'), trigger: 'blur' },
                ],
                zh: [
                    { required: true, message: this.$t('required'), trigger: 'blur' },
                ],
                zh_ft: [
                    { required: true, message: this.$t('required'), trigger: 'blur' },
                ],
                en: [
                    { required: true, message: this.$t('required'), trigger: 'blur' },
                ],
                fr: [
                    { required: true, message: this.$t('required'), trigger: 'blur' },
                ],
                de: [
                    { required: true, message: this.$t('required'), trigger: 'blur' },
                ],
                es: [
                    { required: true, message: this.$t('required'), trigger: 'blur' },
                ],
                ja: [
                    { required: true, message: this.$t('required'), trigger: 'blur' },
                ],

            }
        },


    },
    created() {

    },
    methods: {
        setThumbUrl(obj) {
            // console.log(obj)
            this.formData.fileId = obj.data
            this.formData.fileName = obj.file.name
        },
        setSelectVal(e, key) {
            this.formData[key] = e.nameVal + ''
        },
        selectT(val) {
            this.formData['releaseDate1'] = val
            this.formData['releaseDate'] = new Date(val).getTime()

        },
        subData(name) {//提交表单

            // if(!this.formData.fileId){
            //     common.msg('error',this.$t('appVersion.titleName.fileName')+this.$t('required'))
            //     return
            // }



            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.disabled = true;
                    // this.formData.osType = this.formData.os
                    this.formData.versionInformation = '#' + '&zh&' + this.formData.zh + '&zh&'
                        + '&zh_TW&' + this.formData.zh_ft + '&zh_TW&'
                        + '&zh_HK&' + this.formData.zh_ft + '&zh_HK&'
                        + '&en&' + this.formData.en + '&en&'
                        + '&fr&' + this.formData.fr + '&fr&'
                        + '&de&' + this.formData.de + '&de&'
                        + '&es&' + this.formData.es + '&es&'
                        + '&ja&' + this.formData.ja + '&ja&'
                        + '#'
                    let params = {
                        id:this.formData.id,
                        pageId: this.formData.pageId*1,
                        pageVersion:  this.formData.pageVersion,
                        appVersion: this.formData.appVersion,
                        os: this.formData.os*1,
                        releaseType:this.formData.releaseType*1,
                        versionStatus:this.formData.versionStatus*1,
                        fileId: this.formData.fileId,
                        remark: this.formData.remark,
                        versionInformation: this.formData.versionInformation,
                        releaseDate:this.formData.releaseDate,
                        dealerId: this.selectId
                    }
                    if (this.type == 1) {
                        delete params.id
                    }

                    let url = this.type == 1 ? this.config.urlArray.pageVersionAdd : this.config.urlArray.pageVersionSet
                    this.axios.post(url, params).then((result) => {

                        common.ajaxMsg(result.data, true, () => {//提交表单后的回调处理
                            this.resetForm();//重置表单
                            this.fn()
                        }, () => { this.disabled = false })

                    }).catch((err) => {
                        this.disabled = false
                        console.log(err)
                    });

                }
            })
        },
        cancel() {//对话框关闭
            // this.$emit('update:showModel',false);
            // this.$emit('update:offModel',true);
            this.resetForm()
        },
        resetForm() {//重置表单


            this.$refs.formData.resetFields();//重置表单
            this.$emit('update:showModel', false);
            this.$emit('update:offModel', true);
            Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
            this.formData.os = '1'
            this.formData.osType = '1'
            this.formData.releaseType = '0'
            this.formData.versionStatus = '1'
            this.formData.versionInformation = ''
            this.formData.innerLink = ''
            this.formData.fileId = ''
            this.formData.fileName = ''

            // console.log('this.formData111',this.formData)
            this.disabled = false;//恢复提交按钮为激活状态
        }
    }
}
</script>
